import { LoadingButton } from '@mui/lab';
import { Tab, Tabs, TextField, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import React, { FormEvent, useMemo, useState } from 'react';
import { IPagesDto } from '../../PagesPage.type';
import styles from './PageModal.module.css';
import { ACTIVE_TAB } from '../../../BlogPage/components/PostForm/consts';
import { chooseLangAccordingToTab } from '../../../ServicesPage/components/useServiceInfoForm';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { PAGES, PAGES_SELECT } from '../../../../types/types';

interface PageFormProps {
  onSubmit: (Page: IPagesDto) => void;
  createdPages?: string[];
  onCancel: () => void;
  isEdit?: boolean;
  defaultValue?: {
    page: string;

    titleEn?: string | undefined;
    templateEn?: string | undefined;
    descriptionEn?: string | undefined;
    h1En?: string | undefined;

    titleRu?: string | undefined;
    templateRu?: string | undefined;
    descriptionRu?: string | undefined;
    h1Ru?: string | undefined;

    titlePl?: string | undefined;
    templatePl?: string | undefined;
    descriptionPl?: string | undefined;
    h1Pl?: string | undefined;

    titleUk?: string | undefined;
    templateUk?: string | undefined;
    descriptionUk?: string | undefined;
    h1Uk?: string | undefined;

    payload?: any | undefined;
  };
  loading: boolean;
}

export const PageForm = ({
  onSubmit,
  defaultValue,
  onCancel,
  loading,
  isEdit,
  createdPages
}: PageFormProps) => {
  const [page, setPage] = useState(
    defaultValue || {
      page: '',
      titleEn: '',
      templateEn: '',
      descriptionEn: '',
      h1En: '',

      titleRu: '',
      templateRu: '',
      descriptionRu: '',
      h1Ru: '',

      titlePl: '',
      templatePl: '',
      descriptionPl: '',
      h1Pl: '',

      titleUk: '',
      templateUk: '',
      descriptionUk: '',
      h1Uk: '',
      payload: {},
    },
  );

  const [activeTabIndex, setActiveTabIndex] = useState(ACTIVE_TAB.POLISH);

  const title = `title${chooseLangAccordingToTab(activeTabIndex)}` as 'titleEn' | 'titleRu' | 'titleUk' | 'titlePl';
  const template = `template${chooseLangAccordingToTab(activeTabIndex)}` as 'templateEn' | 'templateRu' | 'templateUk' | 'templatePl';
  const description = `description${chooseLangAccordingToTab(activeTabIndex)}` as 'descriptionEn' | 'descriptionRu' | 'descriptionUk' | 'descriptionPl';
  const h1 = `h1${chooseLangAccordingToTab(activeTabIndex)}` as 'h1En' | 'h1Ru' | 'h1Uk' | 'h1Pl';

  const onSubmitHdl = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isSubmitBtnDisabled) return;

    onSubmit(page as IPagesDto);
  };

  const isSubmitBtnDisabled = useMemo(() => {
    return !page?.page.trim();
  }, [page, defaultValue]);

  const onTabClick = (_: React.SyntheticEvent, nextIndex: number) => {
    setActiveTabIndex(nextIndex);
  };

  return (
    <form className={styles.form} onSubmit={onSubmitHdl} noValidate>
      <Select
        fullWidth
        disabled={isEdit}
        value={page.page}
        onChange={(e) => setPage({ ...page, page: e.target.value })}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
      >
        {PAGES_SELECT.map((item) => (
          <MenuItem disabled={createdPages?.includes(item)} key={item} value={item}>
            <Typography>{item}</Typography>
          </MenuItem>
        ))}
      </Select>
        {defaultValue?.page === 'Global' && (
          <TextField
            name="discount"
            label="Discount"
            value={page?.payload?.discount}
            variant="standard"
            onChange={(e) =>
              setPage((page): any => ({
                ...page,
                payload: {
                  discount: e.target.value,
                },
              }))
            }
          />
        )}
      <div className={styles.tabContainer}>
        <Tabs value={activeTabIndex} onChange={onTabClick}>
          <Tab label={<TabLabel label="Polish"  />} />
          <Tab
            label={<TabLabel label="English"  />}
          />
          <Tab
            label={<TabLabel label="Russian"  />}
          />
          <Tab
            label={<TabLabel label="Ukranian"  />}
          />
        </Tabs>
      </div>

      <TextField
        name="title"
        label="Title"
        value={page[title]}
        variant="standard"
        onChange={(e) =>
          setPage((page): any => ({
            ...page,
            [title]: e.target.value,
          }))
        }
      />
      <TextField
        name="description"
        label="Description"
        value={page[description]}
        variant="standard"
        onChange={(e) =>
          setPage((page): any => ({
            ...page,
            [description]: e.target.value,
          }))
        }
      />
      {page?.page === PAGES.GLOBAL && <TextField
        name="template"
        label="Template"
        value={page[template]}
        variant="standard"
        onChange={(e) =>
          setPage((page): any => ({
            ...page,
            [template]: e.target.value,
          }))
        }
      />}
      <TextField
        name="h1"
        label="H1"
        value={page[h1]}
        variant="standard"
        onChange={(e) =>
          setPage((page): any => ({
            ...page,
            [h1]: e.target.value,
          }))
        }
      />
      <DialogActions>
        <Button disabled={loading} variant="outlined" onClick={onCancel}>
          CANCEL
        </Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="contained"
          disabled={isSubmitBtnDisabled}
        >
          SAVE
        </LoadingButton>
      </DialogActions>
    </form>
  );
};

const TabLabel = ({ label }: { label: string }) => {
  return (
    <div className={styles.tabItem}>
      <Typography variant="body1" >
        {label}
      </Typography>
    </div>
  );
};
